import { ExternalRedirectButton } from '@/components/blocks/buttons/ExternalRedirectButton';

const BrowseInvestmentProperties = () => {
  return (
    <div
      className="flex flex-col items-start justify-center gap-6 rounded-lg px-10 py-12"
      style={{
        backgroundImage: "url('/static/images/florida-aerial.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '200px',
      }}
    >
      <h2 className="font-raleway text-2xl font-bold text-white text-shadow-[1px_1px_8px_#000,-1px_-1px_8px_#000] md:text-3xl">
        Browse Investment Properties
      </h2>
      <ExternalRedirectButton href="/properties" label="Click Here to Start" />
    </div>
  );
};

export { BrowseInvestmentProperties };
